module.exports = __webpack_public_path__ + "img/atelier-ms-fevrier-2025-planning.b51fce5.jpg";